import { z } from "zod"

import { DATE_PRESETS } from "@costory/types/filters"
import { DatePreset } from "@costory/types/prisma-client"

export type SelectedVirtualDimensionsValuesSearchParams = z.infer<
  typeof selectedVirtualDimensionsValuesSearchParamsSchema
>
export const selectedVirtualDimensionsValuesSearchParamsSchema = z
  .object({
    bqName: z.string(),
    values: z.array(z.string()),
  })
  .array()

// Unified dashboard search params schema
export const dashboardSearchParamsSchema = z.object({
  // Date range parameters
  from: z.string().optional(),
  to: z.string().optional(),
  datePreset: z
    .enum(DATE_PRESETS as unknown as [DatePreset, ...DatePreset[]])
    .optional(),

  // Virtual dimensions parameters
  selectedVirtualDimensionsValues: z.string().optional(),
})

export type DashboardSearchParams = z.infer<typeof dashboardSearchParamsSchema>

// Individual parameter schemas for validation
export const dateRangeSchema = z.object({
  from: z.string(),
  to: z.string(),
  datePreset: z
    .enum(DATE_PRESETS as unknown as [DatePreset, ...DatePreset[]])
    .optional(),
})

export const virtualDimensionsSchema = z.object({
  selectedVirtualDimensionsValues: z.string(),
})

export type DateRangeParams = z.infer<typeof dateRangeSchema>
export type VirtualDimensionsParams = z.infer<typeof virtualDimensionsSchema>
